<fui-chrome-control-link (click)="open()" [title]="'wbo.chrome.button.help'">
    <fui-icon [height]="15" [icon]="'question-mark'" [width]="18"></fui-icon>
</fui-chrome-control-link>
